import Swiper, { Navigation, Autoplay } from 'swiper';
if (customElements.get('component-gallery') === undefined) {
    class Gallery extends HTMLElement {
        constructor() {
            super();
            this.swiper = this.querySelector('.swiper');
            this.carousel = null;
            this.prev = this.querySelector('.swiper-button-prev');
            this.next = this.querySelector('.swiper-button-next');
            this.style.display = 'block';
            this.style.position = 'relative';
        }
        static get observedAttributes() {
            return [];
        }
        attributeChangedCallback(attr, oldVal, newVal) {
            if (oldVal !== newVal) {
                this[attr] = newVal;
            }
        }
        connectedCallback() {
            this.setCarousel();
        }
        setCarousel() {
            this.carousel = new Swiper(this.swiper, {
                modules: [Navigation, Autoplay],
                slidesPerView: 1,
                speed: 700,
                //loop: true,
                //freeMode: true,
                //freeModeMomentum: true,
                autoplay: {
                    delay: 5000,
                },
                navigation: {
                    nextEl: this.next,
                    prevEl: this.prev,
                },
            });
        }
    }
    customElements.define('component-gallery', Gallery);
}
